addEventListener("load", _=> {
    new Swiper('#brandSlider', {
        pagination: {
            el: '.swiper-pagination',
            clickable: true
        },
        autoplay: {
            delay: 3000,
            pauseOnMouseEnter: true,
            disableOnInteraction: true
        },
        slidesPerView: 2,
        spaceBetween: 8,
        breakpoints: {
            767: {
                // md
                slidesPerView: 3,
                spaceBetween: 15,
            },
            991: {
                // lg
                slidesPerView: 4,
                spaceBetween: 15,
            },
            1199: {
                // xl
                slidesPerView: 5,
                spaceBetween: 15,
            }
        }
    })

    const querySwiper = document.querySelector('.swiper-container');
    if (querySwiper !== null)
    {
        const swiper = querySwiper.swiper;
    

        const mouseTarget = document.getElementById('brandSlider');
        
        if(mouseTarget !== null) {
            mouseTarget.addEventListener('mouseenter', e => {
                swiper.autoplay.stop();
            });

            mouseTarget.addEventListener('mouseleave', e => {
                swiper.autoplay.start();
            });
        }
    }
})